import React from 'react';

type Tone = 'green' | 'purple' | 'sky' | 'coral' | 'amber' | 'slate';

// Soft tinted fills, no border — calmer than ink-outlined pills when many
// appear together (labels, teams, statuses) across dense dashboard screens.
const TONES: Record<Tone, string> = {
    green: 'bg-[#dcfce7] text-[#15803d]',
    purple: 'bg-[#f3e8ff] text-[#7e22ce]',
    sky: 'bg-[#e0f2fe] text-[#075985]',
    coral: 'bg-[#ffe4e6] text-[#be123c]',
    amber: 'bg-[#fef3c7] text-[#92600a]',
    slate: 'bg-[#ece8db] text-[#6f6b60]',
};

interface TagProps {
    tone?: Tone;
    className?: string;
    children: React.ReactNode;
}

/** Small tinted pill used for teams, labels, statuses. */
export const Tag: React.FC<TagProps> = ({tone = 'green', className = '', children}) => (
    <span className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-[11px] font-bold ${TONES[tone]} ${className}`}>
        {children}
    </span>
);

export default Tag;
